import App from './App'
import ModelLineSelect from './ModelLineSelect'
import ModelView from './ModelView'
import TrimView from './TrimView'
import NoIncentiveView from './NoIncentiveView'

/**
 * Initial Entry point for the page view, Calls to App which determines
 * which view we're on, errors to throw etc.
 */
export default {
  App,
  ModelLineSelect,
  ModelView,
  TrimView,
  NoIncentiveView,
}



/** WEBPACK FOOTER **
 ** ./src/pages/index.js
 **/